// FEAT-022/024 공용 기간 필터 — Issue History / Customer Licenses / Allocation History
// 등에서 동일 UX 로 사용. preset 프리셋 + custom 시 from/to date input 노출.
// label prop 지정 시 'all' 옵션에만 prefix 부착하여 "Expires: All" / "Status: All" 와
// 동일 패턴으로 식별성 부여.
//
// 외부 소비 흐름 (부모 컴포넌트):
//   const [filter, setFilter] = useState({ preset: '7d', from: '', to: '' });
//   const range = useMemo(() => computeRange(filter), [filter]);
//   <PeriodFilter value={filter} onChange={setFilter} />

import React from 'react';
import { Translate as t } from '../../config/Translate';

// preset/custom 입력을 ms timestamp 범위로 변환. 'all' 또는 invalid → undefined 로 미적용 의미.
export const computeRange = (filter) => {
    if (!filter) return { fromTs: undefined, toTs: undefined };
    const now = Date.now();
    const dayMs = 24 * 60 * 60 * 1000;
    if (filter.preset === 'custom') {
        const f = filter.from ? new Date(filter.from).getTime() : NaN;
        const tEnd = filter.to ? new Date(filter.to).getTime() + (dayMs - 1) : NaN;
        if (Number.isFinite(f) && Number.isFinite(tEnd)) return { fromTs: f, toTs: tEnd };
        return { fromTs: undefined, toTs: undefined };
    }
    if (filter.preset === 'all') return { fromTs: undefined, toTs: undefined };
    if (filter.preset === 'today') {
        // 로컬 자정 ~ 다음 자정 직전 (사용자 시간대 기준).
        const start = new Date();
        start.setHours(0, 0, 0, 0);
        return { fromTs: start.getTime(), toTs: start.getTime() + dayMs - 1 };
    }
    const days = { '7d': 7, '30d': 30, '90d': 90, '1y': 365 }[filter.preset] ?? 7;
    return { fromTs: now - days * dayMs, toTs: now };
};

// 탭 안 필터 줄 공용 감싸기 클래스 — 발급 이력(IssueHistoryFilters)·고객 라이선스(CustomerLicensesTable) 두 줄이 같이 쓴다.
// 필터 컨트롤은 모두 form-*-sm 기본 높이 한 벌이라 줄 안 정렬은 center 하나로 고정한다.
export const FILTER_ROW_CLASS = 'd-flex flex-wrap align-items-center gap-2 mb-2';

const PeriodFilter = ({ value, onChange, label }) => (
    <div className="d-flex flex-wrap align-items-center gap-1">
        <select
            className="form-select form-select-sm w-auto"
            value={value.preset}
            onChange={(e) => onChange({ ...value, preset: e.target.value })}
        >
            <option value="today">{t('common.label.today')}</option>
            <option value="7d">{t('common.label.last7Days')}</option>
            <option value="30d">{t('common.label.last30Days')}</option>
            <option value="90d">{t('common.label.last90Days')}</option>
            <option value="1y">{t('common.label.lastYear')}</option>
            <option value="all">{label ? `${t(label)}: ${t('common.label.all')}` : t('common.label.all')}</option>
            <option value="custom">{t('common.label.custom')}</option>
        </select>
        {value.preset === 'custom' && (
            <>
                <input
                    type="date"
                    className="form-control form-control-sm w-auto"
                    value={value.from}
                    onChange={(e) => onChange({ ...value, from: e.target.value })}
                    aria-label={t('common.label.from')}
                />
                <span className="text-muted small">~</span>
                <input
                    type="date"
                    className="form-control form-control-sm w-auto"
                    value={value.to}
                    onChange={(e) => onChange({ ...value, to: e.target.value })}
                    aria-label={t('common.label.to')}
                />
            </>
        )}
    </div>
);

export default PeriodFilter;
